module.exports = Backbone.Model.extend({
    defaults: {
        password: null,
        hashCode: null,
    },

    getPassword() {
        return this.get('password');
    },

    setPassword(password) {
        this.set('password', password);
    },

    getHashCode() {
        return this.get('hashCode');
    },

    setHashCode(hashCode) {
        this.set('hashCode', hashCode);
    },
});
